import styles from "../ConfiguratorPage.module.css";

export type ShareCopyStatus = "idle" | "success" | "error";

type ShareModalProps = {
  open: boolean;
  onClose: () => void;
  onCopyLink: () => void;
  copyStatus: ShareCopyStatus;
  collaborativeEnabled: boolean;
  onCollaborativeToggle: () => void;
  canToggleCollaborative: boolean;
};

export const ShareModal = ({
  open,
  onClose,
  onCopyLink,
  copyStatus,
  collaborativeEnabled,
  onCollaborativeToggle,
  canToggleCollaborative,
}: ShareModalProps) => {
  if (!open) {
    return null;
  }

  return (
    <div
      className={styles.shareModalBackdrop}
      onClick={onClose}
      role="presentation"
    >
      <div
        className={styles.shareModal}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Share your design"
      >
        <div className={styles.shareModalHeader}>
          <h2 className={styles.shareModalTitle}>Share your design</h2>
          <button
            type="button"
            className={styles.shareModalClose}
            onClick={onClose}
            aria-label="Close share modal"
          >
            ×
          </button>
        </div>

        <div className={styles.shareModalBody}>
          <p className={styles.shareModalHeadline}>We got you covered!</p>
          <p className={styles.shareModalDescription}>
            Save your draft by copying to clipboard and pick it up from where
            you left.
          </p>

          <button
            type="button"
            onClick={onCopyLink}
            className={styles.shareCopyButton}
          >
            <svg
              className={styles.shareCopyIcon}
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
              <path d="M6 16H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" strokeWidth="2" />
            </svg>
            <span>Copy draft to clipboard</span>
          </button>
          {copyStatus === "success" && (
            <p className={styles.shareCopyStatusSuccess} role="status">
              Link copied.
            </p>
          )}
          {copyStatus === "error" && (
            <p className={styles.shareCopyStatusError} role="status">
              Unable to copy link. Please copy it manually from your browser.
            </p>
          )}

          <div className={styles.shareToggleRow}>
            <span className={styles.shareToggleLabel}>Viewers can edit:</span>
            <button
              type="button"
              onClick={onCollaborativeToggle}
              className={`${styles.shareToggle} ${collaborativeEnabled ? styles.shareToggleActive : ""}`}
              aria-pressed={collaborativeEnabled}
              aria-label="Toggle viewer edit permission"
              disabled={!canToggleCollaborative}
            >
              <span className={styles.shareToggleThumb} />
            </button>
          </div>
          {!canToggleCollaborative && (
            <p className={styles.shareToggleHelper}>
              Only the configuration owner can change this setting.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
